<template lang="pug">
    include SchoolAdminProfessionals.pug
</template>

<script>
import {es} from 'vuejs-datepicker/dist/locale';
import Api from "@/components/services/Api";
import Datepicker from 'vuejs-datepicker';
import _ from "underscore";
import moment from "moment";

export default {
    name: 'SchoolAdminProfessionals',
    components: {Datepicker},
    data() {
        return {
            es,
            items: [],
            page: 0,
            loading: true,
            filter: {
                query: null,
                date_from: null,
                date_to: null,
            },
            appliedFilter: {
                query: null,
                date_from: null,
                date_to: null,
            },
            paginator: {
                count: null,
                has_next: true,
                has_previous: null,
                page: null,
                pages: null,
            }
        };
    },
    created() {
        this.nextPage();
    },
    methods: {
        prevPage() {
            if (!this.paginator.has_previous) return;
            this.loading = true;
            this.page -= 1;
            this.performRequest();
        },
        nextPage() {
            if (!this.paginator.has_next) return;
            this.loading = true;
            this.page += 1;
            this.performRequest();
        },
        preparePost(data) {
            return {
                query: data.query,
                date_from: (data.date_from) ? moment(data.date_from).format("YYYY-MM-DD"): null,
                date_to: (data.date_to) ? moment(data.date_to).format("YYYY-MM-DD"): null,
            };
        },
        performRequest() {
            const _this = this;

            Api.professionals(this.$store.state.token, this.preparePost(this.appliedFilter), this.page).then(resp => {
                let data = resp.data.items;
                _this.items = data;
                _this.loading = false;

                // Add pager information
                this.paginator.count = resp.data.count;
                this.paginator.has_next = resp.data.has_next;
                this.paginator.has_previous = resp.data.has_previous;
                this.paginator.page = resp.data.page;
                this.paginator.pages = resp.data.pages;
            }).catch(err => {
                _this.loading = false;
            });
        },
        search() {
            this.appliedFilter.query = this.filter.query;
            this.appliedFilter.date_from = this.filter.date_from;
            this.appliedFilter.date_to = this.filter.date_to;
            this.page = 0;

            this.paginator.has_next = true;
            this.nextPage();
        },
        download() {
            // Create the GET link url
            let token = this.$store.state.token;
            let url = Api.getApiUrl() + "/esreps/school-export/?token="+token+"&json=" + JSON.stringify(_.pick(this.appliedFilter, ...["query", "date_from", "date_to"]));
            window.location = url;
        }
    },
    filters: {
        license(value) {
            if (!value.licenses.length) return "~";
            let firstLicense = _.first(value.licenses);
            return firstLicense.license;
        },
        expedition(value) {
            if (!value.licenses.length) return "~";
            let firstLicense = _.first(value.licenses);
            let datetime = moment(firstLicense.expedition_date);
            return datetime.format("DD/MM/YYYY");
        }
    }
}

</script>

<style scoped lang="scss">
@import "./../../variables";
@import "SchoolAdminProfessionals";
</style>



// WEBPACK FOOTER //
// src/components/school_admin_professionals/SchoolAdminProfessionals.vue